module.exports = __webpack_public_path__ + "img/speaker-RachelRamsey.e28a367e.png";